/** コンサルタント 案件メンバー：ステータス 提案メンバー */
export const RFP_OFFER_MEMBER_STATUS_OFFER_MEMBER = {
    label: '提案メンバー',
    value: 1,
};
/** コンサルタント 案件メンバー：ステータス 案件共有のみ */
export const RFP_OFFER_MEMBER_STATUS_VIEW_ONLY = {
    label: '案件共有のみ',
    value: 2,
};
/** コンサルタント 案件メンバー：ステータス一覧 */
export const RFP_OFFER_MEMBER_STATUSES = [
    RFP_OFFER_MEMBER_STATUS_OFFER_MEMBER,
    RFP_OFFER_MEMBER_STATUS_VIEW_ONLY,
];
